import {useUKPBAuth} from "../../Providers/AuthProvider";
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../Api/UsersEndpoints';
import { useEffect } from 'react';

type ProtectedRouteType = {
    blockSingleRoles?: Array<string>;
    children?: any;
}

const ProtectedRoute = (props: ProtectedRouteType) => {
    const { token, loginInProgress, loggingOut, LogIn } = useUKPBAuth();

    useEffect(() => {
        if (!token  && !loginInProgress && !loggingOut.current) {
            LogIn();
        }
    }, [])

    if(!token && loginInProgress) {
        return <></>;
    }

    if(token) {
        return <CheckUser {...props} />;
    }

    return <></>;
};

const CheckUser = (props: ProtectedRouteType) => {
    const navigate = useNavigate();
    const { data } = useUser();

    if(data && data.roles.length === 1 && props.blockSingleRoles?.some((r: string) => data.roles.indexOf(r) >= 0)) {
        return navigate('/sends-page')
    } else {
        return props.children;
    }
}

export default ProtectedRoute;
